module.exports = "//public.zight.com/packs/media/images/icons-new-gray-2da5c6b0420c9070a0b2e538ae28b893.svg";